import { DataTable } from "@/components/custom/data-table";
import { Stack, styled, Typography } from "@mui/material";
import { getRefereesColumns } from "./_components/referees-column";
import CustomPagination from "@/components/custom/custom-pagination";
import { useParams, useSearchParams } from "react-router-dom";
import { useReferees } from "@/hooks/use-referees";
import { CustomButton } from "@/components/custom/custom-button";
import { useState } from "react";
import { createReferee, updateReferee } from "@/services/referral.service";
import RefereeDialog from "./_components/referee-dialog";

const SectionRoot = styled("section")(({ theme }) => ({
  margin: theme.spacing(2),
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

const Card = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: "16px 20px",
  borderRadius: "8px",
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

const Referees = () => {
  const [newRefereeOpen, setNewRefereeOpen] = useState(false);
  const [updateReferralOpen, setUpdateReferralOpen] = useState(false);
  const [editReferee, setEditReferee] = useState(null);

  const [searchParams] = useSearchParams();
  const searchValue = searchParams.get("search") || "";
  const currentPage = Number(searchParams.get("page") || 0);
  const pageSize = Number(searchParams.get("size") || 10);

  const { userId } = useParams();

  const queryParams = {
    page: currentPage,
    size: pageSize,
    search: searchValue,
  };

  const { data, isLoading, error } = useReferees(userId, true, queryParams);

  const handleEditClick = (referee) => setEditReferee(referee);
  const handleEditClose = () => setEditReferee(null);

  return (
    <SectionRoot>
      <Card>
        <Stack
          direction="row"
          spacing={3}
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography fontWeight={500} fontSize={18}>
            Referees
          </Typography>

          <Stack direction="row" spacing={1}>
            <CustomButton
              variantType="outline"
              onClick={() => setUpdateReferralOpen(true)}
              isLoading={false}
              sx={{ height: 35 }}
            >
              Update Referral
            </CustomButton>

            <CustomButton
              variantType="outline"
              onClick={() => setNewRefereeOpen(true)}
              isLoading={false}
              sx={{ height: 35 }}
            >
              Add Referee
            </CustomButton>
          </Stack>
        </Stack>

        <DataTable
          columns={getRefereesColumns(handleEditClick)}
          data={data?.data?.data ?? []}
          isLoading={isLoading}
          isError={!!error}
        />
        <CustomPagination
          total={data?.data?.totalCount ?? 0}
          perPageOptions={[5, 10, 20, 50, 100]}
        />
      </Card>

      <RefereeDialog
        open={newRefereeOpen}
        onClose={() => setNewRefereeOpen(false)}
        mutationFn={createReferee}
        mode="addReferee"
      />

      <RefereeDialog
        open={updateReferralOpen}
        onClose={() => setUpdateReferralOpen(false)}
        mutationFn={updateReferee}
        mode="updateReferral"
      />

      <RefereeDialog
        open={Boolean(editReferee)}
        onClose={handleEditClose}
        referee={editReferee}
        mutationFn={(payload) =>
          updateReferee({ id: editReferee?.id, ...payload })
        }
        mode="addReferee"
      />
    </SectionRoot>
  );
};

export default Referees;
